import { ActiveBuildIndicator } from '@/features/Transition360/ActiveBuildIndicator';
import { Navigate, Outlet, createFileRoute } from '@tanstack/react-router';

import { useTransition360Access } from '@/hooks/useTransition360Access';

function Transition360Gate() {
    // isPending, not isLoading: the query is idle without data while the persisted cache restores.
    const { canAccess, isPending, isFetching } = useTransition360Access();

    if (isPending) {
        return null;
    }

    if (!canAccess) {
        // A restored list can be stale, so only send the user home once the refetch settles.
        return isFetching ? null : <Navigate to="/" />;
    }

    // A flex column so a page's h-full shrinks by the indicator's height instead of overflowing.
    return (
        <div className="flex h-full min-h-0 flex-col">
            <ActiveBuildIndicator />
            <Outlet />
        </div>
    );
}

export const Route = createFileRoute('/transition-360')({
    component: Transition360Gate,
});
